import { Component, Input } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { LoyaltyProgram } from 'src/app/assabil-sales/models/entities/loyalty-program';
import { LoyaltyService } from 'src/app/assabil-sales/services/sales-loyalty-service';
import { SpecificDanoneService } from 'src/app/assabil-sales/services/specific_danone_service';



@Component({
  selector: 'loyalty-bonus-followup-partner-list',
  templateUrl: './loyalty-bonus-followup-partner-list.component.html',
  styleUrls: ['./loyalty-bonus-followup-partner-list.component.scss']
})
export class LoyaltyBonusFollowupPartnerListComponent extends BasePage2<LoyaltyProgram> {

  
  @Input() periodActiveDay    : Date;
  @Input() loyaltyProgram     : string;
  @Input() geoAreaCode        : string;
  @Input() kpi                : string;

  // Filter fields
  // -------------------------------------------------------------------------------------
  withVoucher           : boolean;
  consumedVoucher       : boolean;
  notyetConsumedVoucher : boolean;
  nearlyExpiredVoucher  : boolean;

  // -------------------------------------------------------------------------------------
  loyaltyBonusFollowupPartners : any[] = [];
  // -------------------------------------------------------------------------------------

  title = "";
  // -------------------------------------------------------------------------------------

  
//--------------------------------------------------------------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected specificDanoneService    : SpecificDanoneService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "loyaltyBonusFollowupPartner";
  }
//--------------------------------------------------------------------------------------------------------

  
//--------------------------------------------------------------------------------------------------------
  ngOnInit() {
    //assigner periodActiveDay !!!!
    
    if (! this.embeded) return;
    this.loadData();
    this.title = "Détail des Clients " + this.loyaltyProgram;
  }
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
getRows(): LoyaltyProgram[] {
      return this.loyaltyBonusFollowupPartners;
  }
//--------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------
loadData() {

  this.withVoucher            = false;
  this.consumedVoucher        = false;
  this.notyetConsumedVoucher  = false;
  this.nearlyExpiredVoucher   = false;

  if (this.kpi === "Bonus")
    this.withVoucher = true;
    
  if (this.kpi === "ConsumedBonus")
    this.consumedVoucher = true;
  
  if (this.kpi === "NotyetConsumedBonus")
    this.notyetConsumedVoucher = true;

  if (this.kpi === "NearlyExpiredBonus")
    this.nearlyExpiredVoucher = true;
  
   this.specificDanoneService.danoneLoyaltyBonusFollowupPartnersGet(this.periodActiveDay, this.loyaltyProgram, this.geoAreaCode, 
    this.withVoucher, this.consumedVoucher, this.notyetConsumedVoucher, this.nearlyExpiredVoucher).then(result => {
      this.loyaltyBonusFollowupPartners = result;
  })
}
//--------------------------------------------------------------------------------------------------------

}